import {
    Component,OnInit,OnDestroy,AfterViewInit,Input,ChangeDetectorRef
} from '@angular/core';

@Component({
    selector: "icon-logo-title"
    ,templateUrl: "./icon.logo.title.component.html"
    ,styleUrls: ["./icon.logo.title.component.scss"]
})
export class IconLogoTitleComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    @Input() bgColor:string = "fill-01";
    @Input() borderColor:string = "";
    @Input() imgWidth:string = "";
    @Input() imgHeight:string = "";

    constructor(private changeDetectorRef: ChangeDetectorRef){

    }

    ngOnInit() {}

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {
        let dW = 789;
        let dH = 81;
        if(!this.imgHeight) {
            let cW = parseInt(this.imgWidth);
            let tH = cW * dH / dW;
            this.imgHeight = "" + tH;
        }else{
            let cH = parseInt(this.imgHeight);
            let tW = cH * dW / dH;
            this.imgWidth = "" + tW;
        }
        this.changeDetectorRef.detectChanges();
    }
}